// extracted by mini-css-extract-plugin
module.exports = {"inputs":"input-module--inputs--2BRjI"};